export const PROFILE_OPTIONS = [
  { value: 'profile', label: 'Profile' },
  { value: 'logout', label: 'Sign Out' },
];

export const BUSINESS_TYPES = [
  { value: 'Business', label: 'Business' },
  { value: 'Individual', label: 'Individual' },
  { value: 'NonProfit', label: 'Not for profit' },
];
